module.exports = __webpack_public_path__ + "static/@Mineral-Pool-QLD_1-92f4ca3211e195179f5d9e2229e7a2c3.jpg";